document.addEventListener("DOMContentLoaded", function () {
  var _createClass = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var Animation = (function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }

    _createClass(Animation, null, [
      {
        key: "slideUp",

        /**
         * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
         * force an animation
         */
        value: function slideUp(element) {
          element.style.height = element.scrollHeight + "px"; // Force previous height to allow CSS transition
          element.offsetHeight; // Force redraw
          element.style.height = 0;
        },

        /**
         * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
         * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
         */
      },
      {
        key: "slideDown",
        value: function slideDown(element) {
          if (element.style.height === "auto") {
            return;
          }

          // To do the animation we temporarily hide it, check the height, and transition to it
          element.style.height = element.firstElementChild.scrollHeight + "px";

          var transitionEnded = function transitionEnded(event) {
            if (event.propertyName === "height") {
              element.style.height = "auto"; // Allows the content to grow normally
              element.removeEventListener("transitionend", transitionEnded);
            }
          };

          element.addEventListener("transitionend", transitionEnded);
        },
      },
    ]);

    return Animation;
  })();

  var FaqSection = (function () {
    function FaqSection(element) {
      _classCallCheck(this, FaqSection);
      this.element = element;
      this._attachListeners();
    }

    _createClass(FaqSection, [
      {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.element.querySelectorAll(".folp-faqs__item-question").forEach(
            function (question) {
              question.addEventListener("click", this._toggleItem.bind(this));
            }.bind(this)
          );
          this.element.querySelectorAll(".folp-faqs__item-icon").forEach(
            function (question) {
              question.addEventListener("click", this._toggleItem.bind(this));
            }.bind(this)
          );
        },
      },
      {
        key: "_toggleItem",
        value: function _toggleItem(event) {
          var target = event.target;
          var item = target.closest(".folp-faqs__item");

          if (item.getAttribute("aria-expanded") === "true") {
            this._closeItem(item);
          } else {
            this._openItem(item);
          }
        },
      },
      {
        key: "_openItem",
        value: function _openItem(item) {
          var answerWrapper = item.querySelector(
            ".folp-faqs__item-answer-wrapper"
          );

          item.setAttribute("aria-expanded", "true");

          answerWrapper.setAttribute("aria-hidden", "false");
          Animation.slideDown(answerWrapper, true);
          /*
          this.getSiblings(item, '[aria-expanded="true"]').forEach(function (
            siblingItem
          ) {
            var siblingAnswerWrapper = siblingItem.querySelector(
              ".folp-faqs__item-answer-wrapper"
            );

            siblingItem.setAttribute("aria-expanded", "false");

            siblingAnswerWrapper.setAttribute("aria-hidden", "true");
            Animation.slideUp(siblingAnswerWrapper);
          });
          */
        },
      },
      {
        key: "_closeItem",
        value: function _closeItem(item) {
          var answerWrapper = item.querySelector(
            ".folp-faqs__item-answer-wrapper"
          );

          item.setAttribute("aria-expanded", "false");
          answerWrapper.setAttribute("aria-hidden", "true");
          Animation.slideUp(answerWrapper);
        },
      },
      {
        key: "getSiblings",

        /**
         * Get all the previous and next siblings, optionally filtered by a selector
         */
        value: function getSiblings(element, filter) {
          var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined
              ? arguments[2]
              : false;

          var siblings = [];
          var currentElement = element;

          // Do the previous first
          while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }

          if (includeSelf) {
            siblings.push(element);
          }

          // Then the next side
          currentElement = element;

          while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }

          return siblings;
        },

        /**
         * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
         * we need to normalize it
         */
      },
    ]);

    return FaqSection;
  })();

  document.querySelectorAll(".folp-faqs").forEach(function (element) {
    new FaqSection(element);
  });
});
